import { FC, PropsWithChildren, useEffect } from "react"
import { useSessionStore } from "@app/data/useSessionStore"
import { getOAuthParamsFromUrl } from "./utils"
import { createQueryString, generateState } from "./yandex.types"
import { useOauth2LoginMutation } from "../auth/authApi"
import { getDeviceId } from "./getDeviceId"
const YNADEX_OAUTH_TOKEN = "yandex_oauth_token"
const clientId = import.meta.env.VITE_YANDEX_OAUTH_CLIENT_ID
export type useYandexOAuthResult = () => void
export const useYandexOAuth = (): useYandexOAuthResult => {
	const { set } = useSessionStore()
	const openDialog = () => {
		const tempState = generateState()
		set(YNADEX_OAUTH_TOKEN, tempState)
		window.open(createQueryString(clientId, tempState), "_blank", "width=500,height=600")
	}

	return openDialog
}

export const YandexOAuthConsumer: FC<PropsWithChildren> = ({ children }) => {
	const { get, remove } = useSessionStore()
	const [query] = useOauth2LoginMutation()
	useEffect(() => {
		const query = getOAuthParamsFromUrl()
		if (query.get('state') === get(YNADEX_OAUTH_TOKEN)) {
			window.opener.postMessage({
				type: 'yandex_oauth',
				code: query.get('code')
			}, window.location.origin)
			window.close()
		}
	}, [])
	useEffect(() => {
		const onMessage = (event: MessageEvent<any>) => {
			if (event.origin !== window.location.origin) {
				return // игнорируем чужие сообщения (безопасность!)
			}
			if (event.data?.type === 'yandex_oauth' && event.data?.code) {
				const code = event.data.code
				remove(YNADEX_OAUTH_TOKEN)
				query({
					code: code,
					provider: "yandex",
					code_verifier: "",
					device_id: getDeviceId()
				})
			}

		}
		window.addEventListener('message', onMessage)
		return () => window.removeEventListener('message', onMessage)
	}, [])
	return <>{children}</>
} 